var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResendIcon = function SvgResendIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    fillRule: "evenodd",
    d: "M13.572 3.6H7.93a5.52 5.52 0 0 0-5.512 5.517 5.516 5.516 0 0 0 5.512 5.508h3.638l-.768.77a.833.833 0 0 0 1.18 1.177l2.185-2.192a.833.833 0 0 0 0-1.178l-2.186-2.183A.833.833 0 0 0 10.8 12.2l.761.76H7.93a3.85 3.85 0 0 1-3.845-3.842 3.85 3.85 0 0 1 3.845-3.85h5.642a3.85 3.85 0 0 1 3.846 3.85c0 .903-.317 1.777-.895 2.463a.834.834 0 0 0 1.275 1.074 5.5 5.5 0 0 0 1.287-3.537A5.52 5.52 0 0 0 13.572 3.6",
    clipRule: "evenodd"
  })));
};
export default SvgResendIcon;